import classNames from "classnames";
import Badge from "../UI/Badge/Badge";
import { twMerge } from "tailwind-merge";

interface SectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  section: any;
  slots?: {
    badge?: {
      css: string;
    };
    title?: {
      css: string;
    };
    subtitle?: {
      css: string;
    };
  };
}

const SectionHeader = ({ className, section, slots, style, ...props }: SectionHeaderProps) => {
  if (!section?.Badge && !section?.Title && !section?.Subtitle) {
    return null;
  }

  return (
    <div
      className={twMerge(classNames("flex flex-col gap-10 text-center", className, section?.SectionHeader?.ClassName))}
      {...props}
    >
      {section?.Badge && (
        <div>
          <Badge
            className={twMerge(classNames("min-w-[100px] justify-center text-vpGray-700", slots?.badge?.css))}
            color="neutral500"
            rounded
            size="large"
            startNode={
              section?.Badge?.StartNode?.data?.attributes && (
                <div
                  className={classNames("h-4 w-4", section?.Badge?.StartNodeClassName)}
                  style={{
                    mask: `url(${section?.Badge?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                    WebkitMask: `url(${section?.Badge?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                  }}
                />
              )
            }
            variant="solid"
          >
            {section?.Badge?.Value}
          </Badge>
        </div>
      )}
      {section?.Title && (
        <h2
          className={twMerge(
            classNames("text-balance text-5xl font-bold", slots?.title?.css, section?.TitleElement?.ClassName)
          )}
          id={section?.TitleElement?.HtmlId}
          style={section?.TitleElement?.Style}
          {...section?.TitleElement?.Rest}
        >
          {section?.Title}
        </h2>
      )}
      {section?.Subtitle && (
        <div
          className={twMerge(
            classNames(
              "text-balance text-xl text-vpGray-700",
              slots?.subtitle?.css,
              section?.SubtitleElement?.ClassName
            )
          )}
          id={section?.SubtitleElement?.HtmlId}
          style={section?.SubtitleElement?.Style}
          {...section?.SubtitleElement?.Rest}
        >
          {section?.Subtitle}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
